import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-start gap-16 md:gap-24">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:w-3/5"
          >
            <h2 className="text-[0.65rem] md:text-xs font-sans tracking-[0.5em] text-accent uppercase font-bold mb-6 md:mb-8">About South Haven Ride Share</h2>
            <h3 className="text-4xl md:text-6xl lg:text-7xl font-serif text-primary leading-tight mb-8 md:mb-10">
              Chris Burrows: <br /> <span className="italic">Your Local Expert.</span>
            </h3>
            
            <div className="space-y-6 md:space-y-8 text-base md:text-xl font-serif text-text-main leading-relaxed font-light">
              <p>
                As a long-time resident of Michigan's sunset coast, Chris Burrows provides more than just a ride—he offers a local concierge experience. Whether you're visiting <strong>Downtown South Haven</strong>, heading to the <strong>North Beach</strong> for sunset, or taking <strong>winery and brewery rides</strong>, Chris is the most trusted name in local transit.
              </p>
              <p>
                From wedding party logistics to safe transportation for summer tourists, South Haven Ride Share bridges the gap left by traditional apps. When you're looking for a <strong>South Haven Uber driver</strong> who actually knows the backroads and the best local spots, you call Chris.
              </p>
              <p className="border-l-2 border-accent pl-6 md:pl-10 italic text-text-muted">
                "Whether you need a quiet cruise to the lighthouse or the full high-energy <strong>Karaoke Van</strong> experience for a bachelorette party—I'm here to make it happen." — Chris Burrows
              </p>
            </div>

            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div>
                <h4 className="font-sans text-[0.65rem] uppercase tracking-widest font-bold text-primary mb-4">Why Choose Us?</h4>
                <ul className="space-y-3 text-sm md:text-base font-serif italic text-text-main">
                  <li>• Locally trusted South Haven driver</li>
                  <li>• LED-lit karaoke party van</li>
                  <li>• Instant call or text booking</li>
                  <li>• Perfect for weddings & bachelorette parties</li>
                  <li>• Late-night safe rides home</li>
                </ul>
              </div>
              <div className="bg-surface p-8 rounded-2xl border border-primary/5">
                <p className="text-xs font-sans uppercase tracking-widest font-bold text-accent mb-2">Summer Tourism</p>
                <p className="text-sm font-serif leading-relaxed">
                  We specialize in Lake Michigan event transportation, offering seamless rides to the harbor, local festivals, and <strong>beach-side hotels</strong>.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:w-2/5 relative w-full lg:sticky lg:top-32"
          >
            <div className="bg-primary p-10 md:p-14 rounded-[2.5rem] shadow-2xl relative z-10 w-full">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-accent/10 rounded-full blur-3xl hidden md:block"></div>
              <h4 className="text-accent text-[0.6rem] md:text-xs font-sans tracking-[0.3em] uppercase font-bold mb-4 md:mb-6">The Experience</h4>
              <h5 className="text-2xl md:text-3xl font-serif text-white mb-6 md:mb-8 leading-tight">LED Karaoke <br/>Party Van</h5>
              <p className="text-white/70 text-sm md:text-base font-light leading-relaxed mb-10">
                Transform your transportation into the highlight of your night. Our custom-fitted van features professional karaoke equipment and synced LED lighting.
              </p>
              
              <div className="space-y-4 pt-8 border-t border-white/10">
                <div className="flex justify-between items-center">
                  <span className="text-white/40 text-[0.6rem] uppercase tracking-widest">Local Knowledge</span>
                  <span className="text-accent font-bold text-base">Expert</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-white/40 text-[0.6rem] uppercase tracking-widest">Sound System</span>
                  <span className="text-accent font-bold text-base">Elite</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-white/40 text-[0.6rem] uppercase tracking-widest">Bachelorette Specialist</span>
                  <span className="text-accent font-bold text-base">Yes</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;